import React, { Suspense, useRef, useEffect } from 'react';
import { Canvas, useFrame, useThree, useLoader } from '@react-three/fiber';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader';
import { OrbitControls as OrbitControlsImpl } from 'three/examples/jsm/controls/OrbitControls';
import ModelUrl from '../assests/usn-tub.glb';

function Controls() {
  const { camera, gl } = useThree();
  const controls = useRef();

  useEffect(() => {
    controls.current = new OrbitControlsImpl(camera, gl.domElement);
    controls.current.enablePan = false;
    controls.current.minDistance = 1.2;
    controls.current.maxDistance = 3.5;
    return () => controls.current.dispose();
  }, [camera, gl]);

  useFrame(() => controls.current && controls.current.update());
  return null;
}

function Tub(props) {
  const ref = useRef();
  const gltf = useLoader(GLTFLoader, ModelUrl, (loader) => {
    const draco = new DRACOLoader();
    draco.setDecoderPath('https://www.gstatic.com/draco/versioned/decoders/1.5.5/');
    loader.setDRACOLoader(draco);
  });

  useFrame(({ clock }) => {
    if (!ref.current) return;
    ref.current.position.y = Math.sin(clock.getElapsedTime() * 1.2) * 0.02;
  });

  return (
    <group ref={ref} {...props} dispose={null}>
      {/* model's own geometry isn't centered on its origin - recentered by hand */}
      <primitive object={gltf.scene} position={[0.6, -0.4, 0.6]} />
    </group>
  );
}

function Loader() {
  return (
    <mesh>
      <boxGeometry args={[0.4, 0.4, 0.4]} />
      <meshBasicMaterial color="#2E2E36" wireframe />
    </mesh>
  );
}

export default function UsnViewer({ style }) {
  return (
    <div style={{ width: '100%', height: '100%', ...style }}>
      <Canvas
        dpr={[1, 2]}
        camera={{ position: [1.6, 1.1, 1.9], fov: 34 }}
        shadowMap
      >
        <ambientLight intensity={0.5} />
        <spotLight position={[2, 3, 2]} angle={0.3} penumbra={1} intensity={1.2} castShadow />
        <spotLight position={[-2, 1, -1]} angle={0.3} penumbra={1} intensity={0.6} />
        <Suspense fallback={<Loader />}>
          <Tub scale={1.4} />
        </Suspense>
        <Controls />
      </Canvas>
    </div>
  );
}
